"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStep = exports.StepContext = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../utils/hooks");
exports.StepContext = react_1.default.createContext(null);
const useStep = (current, children, status, hoverable, onStepChange) => {
    const [scopeCurrent, setScopeCurrent] = react_1.default.useState(0);
    react_1.default.useMemo(() => setScopeCurrent(current), [current]);
    const getContext = react_1.default.useCallback(() => {
        return {
            scopeCurrent,
            status,
        };
    }, [scopeCurrent, status]);
    const getStatus = react_1.default.useCallback((index) => {
        if (status && index === scopeCurrent) {
            return status;
        }
        if (index > scopeCurrent) {
            return 'wait';
        }
        if (index < scopeCurrent) {
            return 'completed';
        }
        return 'process';
    }, [scopeCurrent, status]);
    const prevCount = (0, hooks_1.usePrevious)(0, scopeCurrent);
    if (prevCount !== scopeCurrent) {
        onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(scopeCurrent);
    }
    const stepItems = react_1.default.Children.map(children, (child, index) => {
        return (react_1.default.createElement(exports.StepContext.Provider, { value: getContext() }, react_1.default.cloneElement(child, {
            status: child.props.status || getStatus(index),
            selected: scopeCurrent === index,
            onClick: (event) => {
                var _a, _b;
                if (hoverable) {
                    setScopeCurrent(index);
                }
                (_b = (_a = child.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
            },
            hoverable,
        })));
    });
    return { stepItems };
};
exports.useStep = useStep;
//# sourceMappingURL=useStep.js.map